import React from "react";

import destination_1 from "../../public/wheretogo-beskydy/pustevny/destination_1.png";
import destination_2 from "../../public/wheretogo-beskydy/pustevny/destination_2.png";
import destination_3 from "../../public/wheretogo-beskydy/pustevny/destination_3.png";
import destination_4 from "../../public/wheretogo-beskydy/pustevny/destination_4.png";
import destination_5 from "../../public/wheretogo-beskydy/pustevny/destination_5.png";

import destinationIcon_1 from "../../public/wheretogo-beskydy/pustevny/icon_1.png";
import destinationIcon_2 from "../../public/wheretogo-beskydy/pustevny/icon_2.png";
import destinationIcon_3 from "../../public/wheretogo-beskydy/pustevny/icon_3.png";
import destinationIcon_4 from "../../public/wheretogo-beskydy/pustevny/icon_4.png";


import { useContext } from "react";
import { DarkModeContext } from "../../components/DarkModeProvider"

const Pustevny = () => {

  const { darkMode } = useContext(DarkModeContext);

  return (
    <>
      <section className={`destinations ${darkMode ? 'dark' : 'light'}`}>
        <div class="container">
          <div class="destinations__container">
            <img src={destination_1} alt="" />
            <h1>Pustevny</h1>
            <p>
              Lysá hora je nejvyšším vrcholem Moravskoslezských Beskyd. Lze na
              ní přijít pěšky, vyšlapat na kole a za dobrých sněhových podmínek
              vyjet na běžkách. Leží mezi obcemi Krásná, Malenovice, Ostravice a
              Staré Hamry. Samotnému vrcholu se přezdívá Gigula.
            </p>
          </div>
        </div>
      </section>

      <section className={`destinations__icons ${darkMode ? 'dark' : 'light'}`} >
        <div class="container">
          <div class="destinations__icons--container">
            <div class="destinations__icon">
              <img src={destinationIcon_1} alt="" />
              <p>lanovka</p>
            </div>
            <div class="destinations__icon">
              <img src={destinationIcon_2} alt="" />
              <p>turistická chata</p>
            </div>
            <div class="destinations__icon">
              <img src={destinationIcon_3} alt="" />
              <p>restaurace</p>
            </div>
            <div class="destinations__icon">
              <img src={destinationIcon_4} alt="" />
              <p>běžky</p>
            </div>
          </div>
        </div>
      </section>

      <section className={`destinations__attractions ${darkMode ? 'dark' : 'light'}`}>
        <div class="container">
          <div class="destinations__attractions--container">
            <div class="destinations__attractions--image">
              <img class="destination_1" src={destination_2} alt="" />
              <img class="destination_2" src={destination_3} alt="" />
              <img class="destination_3" src={destination_4} alt="" />
              <img class="destination_4" src={destination_5} alt="" />
            </div>
            <div class="destinations__attractions--content">
              <h2>Zajímavosti</h2>
              <ul>
                <li>
                  Původní lanovka na Ráztoce byla vystavěna v roce 1940 a byla
                  první sedačkovou lanovkou v Evropě.
                </li>
                <li>
                  V polovině 18. století byla zřízena poustevna pro jednoho
                  poustevníka a odtud pochází dnešní název místa. Posledním
                  poustevníkem byl údajně Felix, který ve svém útočišti zemřel
                  snad roku 1784
                </li>
                <li>
                  Později s nárůstem zájmu turistů se rozhodli zvýšit ubytovací
                  a pohostinské kapacity. Proto nechali vybudovat další dvě
                  útulny ve slohu lidové secese. Libušín a Maměnka byly
                  zpřístupněny v roce 1899.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Pustevny;
